import React, { SVGProps } from 'react';

const MatchbackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 15C9.76142 15 12 12.7614 12 10C12 7.23858 9.76142 5 7 5C4.23858 5 2 7.23858 2 10C2 12.7614 4.23858 15 7 15Z"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 15C15.7614 15 18 12.7614 18 10C18 7.23858 15.7614 5 13 5C10.2386 5 8 7.23858 8 10C8 12.7614 10.2386 15 13 15Z"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MatchbackIcon;
